/**
 * Created by tschenkel on 1/13/2015.
 */


import Event = createjs.Event;

export class GenerateInviteCodeEvent extends Event {
    public static INVITE_CODE_GENERATED: string = "inviteCodeGenerated";
    public static GENERATE_INVITE_CODE_FAILED: string = "generateInviteCodeFailed";

    private _statusId: number;
    private _inviteCodeOrLink: string;

    constructor(type: string, statusId: number, inviteCodeOrLink: string = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this._statusId = statusId;
        this._inviteCodeOrLink = inviteCodeOrLink;
    }

    public get statusId(): number {
        return this._statusId;
    }

    public get inviteCodeOrLink(): string {
        return this._inviteCodeOrLink;
    }
}

